// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080904/js/" + chunkId + "." + {"44":"7396ae0e","225":"df72a60d","481":"d924dace","486":"82fd1321","770":"a5d7e2fb"}[chunkId] + ".0.5853725875805967.chunk.js";
};